import {
    CLIP_REQUEST_GET_USER_REQUEST,
    CLIP_REQUEST_GET_USER_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    users: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CLIP_REQUEST_GET_USER_REQUEST:
            return { ...state, loading: true }

        case CLIP_REQUEST_GET_USER_RESULT:
            return { ...state, loading: false, users: action.payload }

        case CLEAR_REDUX:
            return ["", "CHANGE_TIMEZONE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};